import type React from 'react';
import * as m from '@/paraglide/messages';

export const documentKeyPoints = (value?: string | null) =>
  value
    ?.split(' | ')
    .map((point) => point.trim())
    .filter(Boolean) ?? [];

export function SidebarEyebrow({
  children,
  action,
}: {
  children: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div className='mb-3 flex items-center justify-between gap-2'>
      <h3 className='text-[11px] font-semibold tracking-[0.08em] text-muted-foreground uppercase'>
        {children}
      </h3>
      {action}
    </div>
  );
}

export function DocumentSummarySection({
  summary,
  action,
}: {
  summary: string;
  action?: React.ReactNode;
}) {
  return (
    <section>
      <SidebarEyebrow action={action}>{m.public_docs_summary()}</SidebarEyebrow>
      <p className='text-[15px] leading-[1.6] text-foreground'>{summary}</p>
    </section>
  );
}

export function DocumentKeyPointsSection({
  points,
  action,
}: {
  points: string[];
  action?: React.ReactNode;
}) {
  return (
    <section>
      <SidebarEyebrow action={action}>
        {m.public_docs_key_points()}
      </SidebarEyebrow>
      <ul className='flex flex-col gap-3'>
        {points.map((point, i) => (
          <li key={i} className='flex items-start gap-3 text-sm leading-[1.55]'>
            <span className='flex h-[1.55em] shrink-0 items-center'>
              <span className='grid size-[18px] place-items-center rounded-full bg-accent text-[10px] font-semibold text-accent-foreground'>
                {i + 1}
              </span>
            </span>
            <span className='text-foreground'>{point}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export function DocumentDetailsSection({
  authors,
  source,
  category,
  action,
}: {
  authors?: string | null;
  source?: string | null;
  category?: string | null;
  action?: React.ReactNode;
}) {
  return (
    <section>
      <SidebarEyebrow action={action}>{m.public_docs_details()}</SidebarEyebrow>
      <dl className='flex flex-col gap-3 text-sm'>
        {authors && (
          <div>
            <dt className='font-medium text-muted-foreground'>
              {m.read_along_authors()}
            </dt>
            <dd className='text-foreground'>{authors}</dd>
          </div>
        )}
        {source && (
          <div>
            <dt className='font-medium text-muted-foreground'>
              {m.public_docs_source()}
            </dt>
            <dd className='text-foreground'>{source}</dd>
          </div>
        )}
        {category && (
          <div>
            <dt className='font-medium text-muted-foreground'>
              {m.public_docs_category()}
            </dt>
            <dd className='text-foreground'>{category}</dd>
          </div>
        )}
      </dl>
    </section>
  );
}
